import { render, staticRenderFns } from "./TutorCommentForHandoff.vue?vue&type=template&id=642687cc&scoped=true&"
import script from "./TutorCommentForHandoff.vue?vue&type=script&lang=js&"
export * from "./TutorCommentForHandoff.vue?vue&type=script&lang=js&"
import style0 from "./TutorCommentForHandoff.vue?vue&type=style&index=0&id=642687cc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "642687cc",
  null
  
)

export default component.exports